// src/components/intake/IntakeReview.js
//
// Ticket 066 (Advisor Intake I6), screen 6.1, reworked by ticket 069 (D12). Shows an
// exceptions callout on top (the gaps buildReview already finds, in two groups) and
// then ONE ROW PER QUESTION with the answer in plain words and an Edit / Fix this
// link that opens the screen that asks it. Pure display of reviewModel.buildReview()
// and reviewAnswers.buildReviewAnswers(): the client's own in-memory answers, nothing
// stored, nothing sent to analytics, no calculate call. "See my results" goes back to Results.

import React from 'react'
import { calloutGroups } from '../../lib/intake/reviewModel'
import {
  SECTION_NAMES, REVIEW_TITLE, REVIEW_HINT, REVIEW_END_MESSAGE, REVIEW_ROW_LABELS, REVIEW_SKIPPED_NOTE,
  REVIEW_TO_RESULTS_LABEL, REVIEW_CALLOUT_TITLE, REVIEW_CALLOUT_NEEDS, REVIEW_CALLOUT_UNSURE,
  REVIEW_EDIT_LABEL, REVIEW_FIX_LABEL, REVIEW_NO_ISSUES,
} from '../../lib/intake/intakeConfig'

const OPEN_STATUSES = ['open', 'not_sure', 'skipped']

function AnswerRow({ row, onOpen }) {
  const isGap = OPEN_STATUSES.includes(row.status)
  const verb = isGap ? REVIEW_FIX_LABEL : REVIEW_EDIT_LABEL
  return (
    <li className={`intake-review-row${isGap ? ' intake-review-gap' : ''}`}>
      <div className="intake-review-text">
        <span className="intake-review-label">{row.question}</span>
        <span className={`intake-review-answer intake-status--${row.status}`}>{row.answerText}</span>
        {row.status === 'skipped' && <span className="u-hint">{REVIEW_SKIPPED_NOTE}</span>}
      </div>
      {row.fixScreen && (
        <button type="button" className="btn-secondary" aria-label={`${verb}: ${row.question}`} onClick={() => onOpen(row.fixScreen)}>
          {verb}
        </button>
      )}
    </li>
  )
}

function CalloutGroup({ title, gaps, onOpen }) {
  if (gaps.length === 0) return null
  return (
    <div className="intake-callout-group">
      <h3 className="intake-callout-heading">{title}</h3>
      <ul className="intake-review-list">
        {gaps.map((g) => {
          const label = REVIEW_ROW_LABELS[g.screen]
          return (
            <li className="intake-review-row" key={`${g.screen}:${g.status}`}>
              <span className="intake-review-label">{label}</span>
              <button type="button" className="btn-secondary" aria-label={`${REVIEW_FIX_LABEL}: ${label}`} onClick={() => onOpen(g.fixScreen)}>
                {REVIEW_FIX_LABEL}
              </button>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default function IntakeReview({ review, rows, notice, onOpen, onResults }) {
  const { needs, unsure } = calloutGroups(review)
  const hasIssues = needs.length + unsure.length > 0
  return (
    <div className="intake-review">
      <h1 className="triage-question">{REVIEW_TITLE}</h1>
      {notice && <p className="intake-notice">{notice}</p>}
      <p className="triage-hint">{REVIEW_HINT}</p>
      {hasIssues ? (
        <section className="intake-callout" aria-label={REVIEW_CALLOUT_TITLE}>
          <h2 className="intake-results-heading">{REVIEW_CALLOUT_TITLE}</h2>
          <CalloutGroup title={REVIEW_CALLOUT_NEEDS} gaps={needs} onOpen={onOpen} />
          <CalloutGroup title={REVIEW_CALLOUT_UNSURE} gaps={unsure} onOpen={onOpen} />
        </section>
      ) : (
        <p className="triage-hint">{REVIEW_NO_ISSUES}</p>
      )}
      {[1, 2].map((section) => (
        <section key={section} className="intake-review-section">
          <h2 className="u-form-label">{SECTION_NAMES[section]}</h2>
          <ul className="intake-review-list">
            {rows.filter((r) => r.section === section).map((row) => (
              <AnswerRow key={row.id} row={row} onOpen={onOpen} />
            ))}
          </ul>
        </section>
      ))}
      <p className="intake-notice">{REVIEW_END_MESSAGE}</p>
      <div className="intake-actions">
        <button type="button" className="btn-primary" onClick={onResults}>{REVIEW_TO_RESULTS_LABEL}</button>
      </div>
    </div>
  )
}
